// extracted by mini-css-extract-plugin
export default {"tabs":"AppTabs_tabs__2x2bR","list":"AppTabs_list__spzaz","is-current":"AppTabs_is-current__METFy"};